import { useAuth } from "@/providers/AuthProvider";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { User } from "@supabase/supabase-js";
import { Link } from "react-router";

interface ProfileDropdownProps {
  user: User;
  onSignOut: () => void;
}

export function ProfileDropdown({ user, onSignOut }: ProfileDropdownProps) {
  const { teams } = useAuth();

  // Check if user has teams
  const hasTeams = teams && teams.length > 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="cursor-pointer h-8 w-8 rounded-full flex items-center justify-center bg-primary text-primary-foreground hover:opacity-90">
          {user.email?.[0].toUpperCase()}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {hasTeams && (
          <DropdownMenuItem className="cursor-pointer" asChild>
            <Link to="/profile">My profile</Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem className="cursor-pointer" onClick={onSignOut}>
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
